// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import todo from '@src/views/apps/todo/store'
import chat from '@src/views/apps/chat/store'
import users from '@src/views/apps/user/store'
import email from '@src/views/apps/email/store'
import invoice from '@src/views/apps/invoice/store'
import calendar from '@src/views/apps/calendar/store'
import ecommerce from '@src/views/apps/ecommerce/store'
import dataTables from '@src/views/tables/data-tables/store'
import permissions from '@src/views/apps/roles-permissions/store'
import configReducer from "../utility/configCalling/reducer"
import loginReducer from "../views/pages/authentication/redux/reducer"
import orderReducer from "../views/orders/reducer"
import customerDetailsReducer from "../views/customerDetails/reducer"
import customerReducer from "../views/customer/reducer"
import orderHistoryReducer from "../views/orderHistory/reducer"
import {combineReducers} from "redux"

const rootReducer = combineReducers({
  auth,
  todo,
  chat,
  email,
  users,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  permissions,
  configReducer,
  loginReducer,
  orderReducer,
  customerReducer,
  customerDetailsReducer,
  orderHistoryReducer
})

export default rootReducer
